module.exports = __webpack_public_path__ + "static/media/alerta-spa.3dfd3a6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alerta-spa.png
// module id = 229
// module chunks = 0